"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateStakingV2Earned = exports.calculateStakingEarned = exports.resolveStakingSummary = exports.STMX_V2_FIXED_SIGNIFICANCE = exports.STMX_FIXED_SIGNIFICANCE = exports.DAY_IN_MILISECONDS = exports.ATH_FIXED_SIGNIFICANCE = exports.TokenTypes = exports.StakingCalculationValues = exports.StakingEvents = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var StakingEvents;
(function (StakingEvents) {
    StakingEvents["COOLDOWN_CHANGED"] = "SetCooldownTimer";
    StakingEvents["STAKED"] = "Staked";
    StakingEvents["TOKEN_LOCKED"] = "TokenLocked";
    StakingEvents["TOKEN_UNLOCKED"] = "TokenUnlocked";
    StakingEvents["UNSTAKED"] = "Unstaked";
})(StakingEvents = exports.StakingEvents || (exports.StakingEvents = {}));
var StakingCalculationValues;
(function (StakingCalculationValues) {
    StakingCalculationValues["UNLINKED_REWARDS_WALLET_THIS_CYCLE"] = "-2";
    StakingCalculationValues["UNSTAKED_THIS_CYCLE"] = "-1";
})(StakingCalculationValues = exports.StakingCalculationValues || (exports.StakingCalculationValues = {}));
var TokenTypes;
(function (TokenTypes) {
    TokenTypes["ATHENS"] = "ATHENS";
    TokenTypes["STORMX"] = "STORMX";
    TokenTypes["STORMX_STAKING_V2"] = "STORMX_STAKING_V2";
    TokenTypes["STORMX_V2"] = "STORMX_V2";
})(TokenTypes = exports.TokenTypes || (exports.TokenTypes = {}));
exports.ATH_FIXED_SIGNIFICANCE = 8;
exports.DAY_IN_MILISECONDS = 86400000;
exports.STMX_FIXED_SIGNIFICANCE = 4;
exports.STMX_V2_FIXED_SIGNIFICANCE = 4;
exports.resolveStakingSummary = function (summary) {
    var date = Date.now();
    // handle the case when user joined during current cycle and there were staking tokens on their wallet
    var startingDate = null;
    var currentWeekNumber = summary.currentWeekNumber, joinedRewardsProgramAt = summary.joinedRewardsProgramAt, joinedWeekNumber = summary.joinedWeekNumber;
    if (joinedWeekNumber === currentWeekNumber &&
        new Date(joinedRewardsProgramAt).getFullYear() === new Date(date).getFullYear()) {
        startingDate = new Date(joinedRewardsProgramAt).getTime();
    }
    var stakingSummary = __assign(__assign({}, summary), { baseDate: date, currentCycleStartedAt: new Date(summary.previousWeekEndedAt).getTime(), startingDate: startingDate });
    return stakingSummary;
};
exports.calculateStakingEarned = function (_a) {
    var baseDate = _a.baseDate, // date on which the calculations are based on
    currentCycleStartedAt = _a.currentCycleStartedAt, // date on which current cycle started at, it's used for rewarding on current week
    cycleSummary = _a.cycleSummary, // stake/unstake events for this cycle (eg. [[1601969215000, true, 100]]: [ts, stake?, amount][])
    divider = _a.divider, // support value used for calculations of daily earnings (eg. 31622400000 for leap years)
    previousCycleLocked = _a.previousCycleLocked, // tokens locked in previous cycle(s)
    rate = _a.rate, // STAKE_RATE from remote config (eg. 0.5 for 50% APY)
    startingDate = _a.startingDate, // if set, dates for cycleSummary items will be set to that value and previous cycle calculations adapted
    tsDifference = _a.tsDifference;
    var calculateStakingPartial = function (amount, rate, divider, weekMultiplier) {
        return new bignumber_js_1.default(amount)
            .multipliedBy(rate) // earnings per year
            .dividedBy(new bignumber_js_1.default(divider).dividedBy(exports.DAY_IN_MILISECONDS)) // earnings per day
            .multipliedBy(weekMultiplier);
    }; // multiplied by days passed
    var calculateWeekMultiplier = function (base, relative) {
        return new bignumber_js_1.default(base)
            .minus(relative) // time difference
            .dividedBy(exports.DAY_IN_MILISECONDS) // divided by days
            .toNumber();
    };
    if (!tsDifference) {
        tsDifference = 0;
    }
    var thisCycleEarnings = new bignumber_js_1.default(0);
    if (startingDate) {
        cycleSummary = cycleSummary.map(function (_a) {
            var timestamp = _a[0], amount = _a[1];
            return [
                startingDate > timestamp ? startingDate : timestamp,
                amount,
            ];
        });
        var weekMultiplier = calculateWeekMultiplier(baseDate - tsDifference, startingDate);
        var partialEarnings = calculateStakingPartial(previousCycleLocked, rate, divider, weekMultiplier);
        thisCycleEarnings = thisCycleEarnings.plus(partialEarnings);
        previousCycleLocked = 0;
    }
    var unstakedThisCycle = false;
    cycleSummary.forEach(function (_a) {
        var timestamp = _a[0], value = _a[1];
        if (!unstakedThisCycle) {
            if (value < 0) {
                unstakedThisCycle = true;
            }
            else if (value > 0) {
                var weekMultiplier = calculateWeekMultiplier(baseDate - tsDifference, timestamp);
                var partialEarnings = calculateStakingPartial(value, rate, divider, weekMultiplier);
                thisCycleEarnings = thisCycleEarnings.plus(partialEarnings);
            }
        }
    });
    // if an unstake event happened this cycle, then there are no earnings for this week
    if (unstakedThisCycle) {
        return new bignumber_js_1.default(StakingCalculationValues.UNSTAKED_THIS_CYCLE);
    }
    else {
        var previousCycleWeekMiltiplier = 7; // the whole week
        if (currentCycleStartedAt) {
            previousCycleWeekMiltiplier = calculateWeekMultiplier(baseDate - tsDifference, currentCycleStartedAt);
        }
        return previousCycleLocked > 0
            ? calculateStakingPartial(previousCycleLocked, rate, divider, previousCycleWeekMiltiplier).plus(thisCycleEarnings)
            : thisCycleEarnings;
    }
};
exports.calculateStakingV2Earned = function (_a) {
    var baseDate = _a.baseDate, // date on which the calculations are based on
    currentCycleStartedAt = _a.currentCycleStartedAt, // date on which current cycle started at, it's used for rewarding on current week
    cycleSummary = _a.cycleSummary, // stake/unstake events for this cycle (eg. [[1601969215000, true, 100]]: [ts, stake?, amount][])
    divider = _a.divider, // support value used for calculations of daily earnings (eg. 31622400000 for leap years)
    previousCycleLocked = _a.previousCycleLocked, // tokens locked in previous cycle(s)
    rate = _a.rate, // STAKE_RATE from remote config (eg. 0.5 for 50% APY)
    startingDate = _a.startingDate, // if set, dates for cycleSummary items will be set to that value and previous cycle calculations adapted
    tsDifference = _a.tsDifference;
    var calculateStakingPartial = function (amount, rate, divider, durationMultiplier) {
        return new bignumber_js_1.default(amount)
            .multipliedBy(rate) // earnings per year
            .dividedBy(divider)
            .multipliedBy(durationMultiplier);
    }; // multiplied by milliseconds passed
    var calculateDurationMultiplier = function (base, relative) { return new bignumber_js_1.default(base).minus(relative); };
    if (!tsDifference) {
        tsDifference = 0;
    }
    var thisCycleEarnings = new bignumber_js_1.default(0);
    var durationMultiplier = new bignumber_js_1.default(exports.DAY_IN_MILISECONDS).multipliedBy(7);
    var currentStakedAmount = new bignumber_js_1.default(previousCycleLocked[0]);
    var currentCooldownAmount = previousCycleLocked[1];
    var currentPrincipalAmount = currentStakedAmount.minus(currentCooldownAmount);
    var startTime = currentCycleStartedAt;
    if (startingDate) {
        // startingDate is not null if the user started to stake in the current week.
        // So the cycleSummary should never be empty if there is a starting date
        if (!cycleSummary.length) {
            return thisCycleEarnings;
        }
        startTime = startingDate;
        currentCooldownAmount = 0;
        currentPrincipalAmount = new bignumber_js_1.default(0);
    }
    cycleSummary.forEach(function (_a) {
        var timestamp = _a[0], value = _a[1], event = _a[2];
        durationMultiplier = calculateDurationMultiplier(timestamp, startTime);
        var partialEarnings = calculateStakingPartial(currentPrincipalAmount, rate, divider, durationMultiplier);
        thisCycleEarnings = thisCycleEarnings.plus(partialEarnings);
        startTime = timestamp;
        if (event === StakingEvents.COOLDOWN_CHANGED) {
            currentPrincipalAmount = currentStakedAmount.plus(value);
            currentCooldownAmount = value;
        }
        else if (event === StakingEvents.UNSTAKED) {
            currentStakedAmount = currentStakedAmount.plus(value);
            currentPrincipalAmount = currentStakedAmount;
            currentCooldownAmount = 0;
        }
        else if (event === StakingEvents.STAKED) {
            currentStakedAmount = currentStakedAmount.plus(value);
            currentPrincipalAmount = currentPrincipalAmount.plus(value);
        }
    });
    durationMultiplier = calculateDurationMultiplier(baseDate - tsDifference, startTime);
    var partialEarnings = calculateStakingPartial(currentPrincipalAmount, rate, divider, durationMultiplier);
    return thisCycleEarnings.plus(partialEarnings);
};
